import PropTypes from 'prop-types'

export const sanityInternalLinkPropTypes = {
  _type: PropTypes.oneOf(['internalLink']),
  reference: PropTypes.shape({
    slug: PropTypes.shape({
      current: PropTypes.string,
    }),
  }),
}

export type SanityInternalLinkProps = PropTypes.InferProps<typeof sanityInternalLinkPropTypes>
